module.exports = __webpack_public_path__ + "img/texiao-_0000s_0015_16.5a1e4281.png";